// src/hooks/useAvailableTimeSlots.js


// TODO : IMPLEMENTAR STATES PARA QUE A FUNÇÃO POSSA ENTREGAR O RESULTADO.


import { useState, useCallback } from 'react';
import { timeToMinutes, isLunchBreak } from '../utils';
import { appointmentService } from '../services/appointmentService';

// Hook responsável em retornar os horários disponíveis.

// O export faz com que este hook se torne acessível aos demais arquivos dentro do projeto.
export const useAvailableTimeSlots = () => {
  const [availableSlots, setAvailableSlots] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const getAvailableTimeSlots = useCallback(
    async (
      selectedDate = null,
      psychologistId = null,
      psychologistWorkLunchInterval = null,
      removeBlocked = false
    ) => {

      setLoading(true);
      setError(null);

      const workBeginTime = '07:00:00';
      const workEndTime = '23:00:00';
      const lunchInterval = psychologistWorkLunchInterval || { start: '12:00', end: '13:00' };
      // Extract hours and minutes
      const [startHour, startMinute] = workBeginTime.split(':').map(Number);
      const [endHour, endMinute] = workEndTime.split(':').map(Number);

      // Generate all possible time slots (30-minute intervals)
      const allSlots = new Set();
      const dateChosen = selectedDate;

      // Verifica se a data selecionada é hoje
      const today = new Date();
      const isToday = today.toDateString() === dateChosen.toDateString();

      // Se for hoje, calcula o horário atual em minutos (ex: 13:45 → 825)
      const nowMinutes = isToday 
        ? today.getHours() * 60 + today.getMinutes() 
        : -1; // -1 = não é hoje → não filtra nada

      let currentTime = new Date(dateChosen);
      currentTime.setHours(startHour, startMinute, 0, 0);

      const endTime = new Date(dateChosen);
      endTime.setHours(endHour, endMinute, 0, 0);

      while (currentTime < endTime) {        
        // timeString recalculado a cada volta do loop
        const timeString = `${String(currentTime.getHours()).padStart(2, '0')}:${String(currentTime.getMinutes()).padStart(2, '0')}`;
        const currentSlotMinutes = timeToMinutes(timeString);

        if (isToday && currentSlotMinutes < nowMinutes) {
            currentTime = new Date(currentTime.getTime() + 30 * 60000);
            continue; // pula para o próximo
          }

        // Se horário não estiver dentro do intervalo de almoço do profissional, inclui na coleção.
        if (!isLunchBreak(timeString, lunchInterval))  {
          allSlots.add(timeString);
        }

        // Avança 30 minutos
        currentTime = new Date(currentTime.getTime() + 30 * 60000);
      }

      const dateObj = selectedDate;

      
      // Agora vamos obter os agendamentos já registrados no banco de dados
      // e, também, os "agendamentos em potencial", ou seja, os que foram marcados
      // através de página pública de agendamento de horário (por clientes desconhecidos, ainda).
      // Fetch existing appointments for the selected date      
      const { data: existingAppointments, error: fetchError } = 
        await appointmentService?.getExistingAppointments(psychologistId, dateObj.toISOString());

      if (fetchError) throw fetchError;

      // Fetch existing temp appointments (new, unknown patients) for the selected date      
      const { data: newPatientsAppointments, error } = 
        await appointmentService?.getTempAppointments(psychologistId, dateObj.toISOString() );

      if (error) throw error;

      // Filter out occupied time slots
      let occupiedSlots = getOccupiedSlots(allSlots, existingAppointments);
      const newOccupied = getOccupiedSlots(allSlots, newPatientsAppointments);

      // Junta tudo em um único Set.
      occupiedSlots = new Set([...occupiedSlots, ...newOccupied]);

      // Fetch blocked appointments for the selected date      
      const { data: blockedAppointments, error: fetchBlockedError } = 
        await appointmentService?.getBlockedAppointments(psychologistId, dateObj.toISOString());

      if (fetchBlockedError) throw fetchBlockedError;

      // Carrega os horários bloqueados.
      const blockedSlots = new Set(
        (blockedAppointments || []).map(apt => apt.start_time.substring(0, 5))
      );

      // Create final available slots list
      let idCounter = 1;
      const availSlots = [...allSlots]
        .filter(slot => !occupiedSlots?.has(slot))
        .filter(slot => !removeBlocked || !blockedSlots?.has(slot))         
        .map(slot => {
          const isBlocked = !removeBlocked && (blockedSlots?.has(slot) ?? false);          
          return {
            value: slot,
            label: slot,
            id: idCounter++,
            isBlocked
          };
        });

      setAvailableSlots(availSlots);
      setLoading(false);

      return availSlots;
  }, []);
  

  const getOccupiedSlots = (allSlots = new Set(), existingAppointments = new Set()) => {
    const occupiedSlots = new Set();

    // Em outras palavras: Estou dizendo pra função: Olha, eu tenho esses horários da minha agenda,
    // que vai de 07:00 às 21:00. E pode ser que já hajam agendados alguns pacientes (registrado no BD).
    // Compare aí e me diga quais desses horários estão ocupados.
    existingAppointments.forEach(apt => {
      const startTime = apt?.start_time?.substring(0, 5);
      const endTime = apt?.end_time?.substring(0, 5);

      if (!startTime || !endTime) return;

      const startMinutes = timeToMinutes(startTime);
      const endMinutes = timeToMinutes(endTime);

      allSlots.forEach(slot => {
        const slotMinutes = timeToMinutes(slot);

        if (slotMinutes >= startMinutes && slotMinutes < endMinutes) {
          occupiedSlots.add(slot);
        }
      });
    });

    return occupiedSlots;
  };

return {
  availableTimeSlots: [...availableSlots],
  loadingAvailableTimeSlots: loading,
  errorAvailableTimeSlots: error,
  getAvailableTimeSlots
};

};